<template>
  <div style="width: 100%">
    <v-breadcrumbs item-text="text" :items="breadcrumbs"></v-breadcrumbs>
    <v-card-title> Create Invoice :
      <v-btn class="ms-2" color="primary"> {{ submitData.invoice_type }}</v-btn>
      <!--      <span v-if="this.invoice_id" class="ms-2" :class="bgColorClass">{{ invoice_created_msg }}</span>-->
    </v-card-title>
    <v-row>
      <v-col cols="3">
        <div>
          <template>
            <v-card class="mx-auto" max-width="" variant="outlined">
              <div>
                <div class="text-overline mb-1 ms-2">
                  <v-btn color="orange" style="margin-top: 5px; color: #FFFFFF">
                    Patient ID: <b>{{ patient_info.patient_id }}</b>
                  </v-btn>
                </div>
                <div class="text-h6 mb-1 ms-2 " style="font-weight: bold">
                  {{ patient_info.patient_name }}
                </div>
                <div class="text-caption ms-2">Gender: <b>{{ patient_info.patient_sex }}</b> | Age:
                  <b>{{ patient_info.patient_age }}</b></div>
              </div>
            </v-card>
          </template>
        </div>
      </v-col>

      <v-col cols="5">
        <div>
          <template>
            <v-card class="mx-auto" max-width="" variant="outlined">
              <div>
                <div class="text-overline mb-1 ms-2">
                  <v-btn color="orange" style="margin-top: 5px; color: #FFFFFF">
                    Reference
                  </v-btn>
                </div>
                <div class="text-h6 mb-1 ms-2 " style="font-weight: bold">
                  {{ patientSource.ps_name }} <span v-if="(patientSource.id === 21) && !submitData.family_eye_card_no"><v-btn
                    color="red" style="color: white">Inactive</v-btn></span>
                </div>
                <div class="text-caption ms-2">Consultation Discount : <b>{{ patientSource.ps_con_discount + '%' }}</b>
                  | Investigation Discount: <b>{{ patientSource.ps_invs_discount + '%' }} </b> | Operation Discount:
                  <b>{{ patientSource.ps_op_discount + '%' }}</b></div>
              </div>
            </v-card>
          </template>
        </div>
      </v-col>
      <v-col cols="4" v-if="submitData.family_eye_card_no">
        <div>
          <template>
            <v-card class="mx-auto" max-width="" variant="outlined">
              <div>
                <div class="text-overline mb-1 ms-2">
                  <v-btn color="orange" style="margin-top: 5px">
                    Family Eye Card
                  </v-btn>
                </div>
                <div class="text-h6 mb-1 ms-2 " style="font-weight: bold">
                  <v-text-field
                      v-model="submitData.family_eye_card_no"
                      hide-details="auto"
                      outlined
                      dense
                      readonly
                  ></v-text-field>
                  <div class="text-caption ms-2">Cashback: <b>৳ {{ this.submitData.cashback_amount }}</b></div>
                </div>
              </div>
            </v-card>
          </template>
        </div>
      </v-col>
      <v-card :loading="loading" class="mx-auto" max-width="" variant="outlined">
        <v-col cols="9">
          <v-container fluid>
            <v-radio-group v-model="submitData.consultation_type" row inline label="Consultation type">
              <v-radio v-if="parseInt(general_consultation_block) === 0" @click="consultationTypeChange" label="General" value="General"  ></v-radio>
              <v-radio v-if="parseInt(show_other_dr_followup) === 1" @click="consultationTypeChange" label="Followup" value="Followup"  ></v-radio>
              <v-radio @click="consultationTypeChange" label="OPD" value="OPD" ></v-radio>
              <v-radio @click="consultationTypeChange" label="ROP" value="ROP"></v-radio>
              <v-radio @click="consultationTypeChange" label="Cycloplegic refraction" value="CycloplegicRefraction"></v-radio>
            </v-radio-group>
          </v-container>
          <v-row>
            <v-col cols="4">
              <v-text-field
                  v-model="doctor_name"
                  label="Consultant Doctor"
                  hide-details="auto"
                  outlined
                  dense
                  readonly
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                  v-model="refer_doctor_name"
                  label="Referral Doctor"
                  hide-details="auto"
                  outlined
                  dense
                  readonly
              ></v-text-field>
            </v-col>
            <v-col cols="4" v-if="submitData.consultation_type === 'CycloplegicRefraction'">
              <div>
                <v-autocomplete
                    :items="doctors"
                    v-model="submitData.paid_service_ref_dr"
                    item-text="dr_name"
                    item-value="id"
                    required
                    label="Select Cycloplegic refer Doctor"
                    outlined
                    dense
                    hide-details
                ></v-autocomplete>
              </div>
            </v-col>
            <v-col cols="4">
              <v-container fluid>
                <v-checkbox
                    v-model="submitData.opd_refer_patient"
                    label="OPD Refer Patient"
                    value="OPD_PATIENT"
                    readonly
                    hide-details
                ></v-checkbox>
              </v-container>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="9">
          <v-row>
            <v-col cols="4">
              <v-text-field
                  v-model="submitData.cons_fee"
                  label="Consultant Fee"
                  hide-details="auto"
                  outlined
                  dense
                  type="number"
                  prefix="৳"
                  disabled
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                  v-model="submitData.cons_fee"
                  label="Sub Total"
                  hide-details="auto"
                  outlined
                  dense
                  type="number"
                  prefix="৳"
                  disabled
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="9">
          <v-row>
            <v-col cols="4">
              <v-text-field
                  v-model="submitData.dis_percentage"
                  label="Discount"
                  hide-details="auto"
                  outlined
                  dense
                  type="number"
                  prefix="%"
                  disabled
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                  v-model="submitData.dis_amount"
                  label="Discount Amount"
                  hide-details="auto"
                  outlined
                  dense
                  type="number"
                  prefix="৳"
                  disabled
              ></v-text-field>
            </v-col>
            <v-col cols="4"></v-col>
            <v-col cols="4">
              <v-text-field
                  v-model="submitData.total_amount"
                  label="Total Amount"
                  hide-details="auto"
                  outlined
                  dense
                  type="number"
                  prefix="৳"
                  disabled
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                  v-model="submitData.paid_amount"
                  label="Paid Amount"
                  hide-details="auto"
                  outlined
                  dense
                  type="number"
                  prefix="৳"
                  readonly
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                  v-model="dueAmount"
                  label="Due Amount"
                  hide-details="auto"
                  outlined
                  dense
                  type="number"
                  prefix="৳"
                  disabled
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                  v-model="submitData.cashback_amount"
                  label="Cashback Amount"
                  hide-details="auto"
                  outlined
                  dense
                  type="number"
                  prefix="৳"
                  disabled
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                  :items="paymentMethods"
                  v-model="submitData.payment_method"
                  item-text="name"
                  item-value="name"
                  required
                  label="Payment Method"
                  outlined
                  dense
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="mb-4">
            <div v-if="spinnerButtons">
              <v-col cols="12">
                <v-progress-circular :width="12" size="61" color="green" indeterminate
                                     style="margin-top: 5px; margin-bottom: 10px"></v-progress-circular>
              </v-col>
            </div>
            <div v-else>
              <v-col cols="12">
                <v-btn depressed color="success" :disabled="btnSubmit" class="mx-2" @click="formSubmit">
                  Submit
                </v-btn>
                <v-btn depressed color="info" v-if="this.invoice_id" @click="print('invoice')">
                  <v-icon>mdi-printer</v-icon>
                  Invoice Print
                </v-btn>
                <v-btn class="ms-2" depressed color="info" v-if="this.invoice_id" @click="print('prescription')">
                  <v-icon>mdi-printer</v-icon>
                  Prescription Print
                </v-btn>
              </v-col>
            </div>
          </v-row>
        </v-col>
      </v-card>
    </v-row>
  </div>
</template>
<style>
.bg-color-red {
  background-color: red;
}

.bg-color-success {
  background-color: green;
}

</style>
<script>

import atshq from "../../../js/setup";
import moment from "moment/moment";

export default {
  data() {
    return {
      spinnerButtons: false,
      loading: true,
      date: moment().format('YYYY-MM-DD'),
      nowDate: moment().format('YYYY-MM-DD'),
      btnSubmit: true,
      items: [],
      patient_info: [],
      appointment: [],
      paymentMethods: [],
      doctor_name: '',
      refer_doctor_name: null,
      dialog: false,
      discountList: [
        0,
        5,
        10,
        15,
        20,
        25,
        30,
        35,
        40,
        45,
        50,
        55,
        60,
        65,
        70,
        75,
        80,
        85,
        90,
        95,
        100,
      ],
      eyeType: ["Left Eye", "Right Eye", "Both Eye"],
      investigations: [],
      doctors: [],
      invoice_discount: 0,
      row: null,
      message: this.$route.query.message,
      show_other_dr_followup: 0,
      general_consultation_block: 0,
      submitData: {
        patient_id: this.$route.query.patient_id,
        doctor: this.$route.query.doctor,
        myopia_refer_doctor: '',
        appointment_id: this.$route.query.appointment_id,
        invoice_type: this.$route.query.type,
        cons_fee: 0,
        consultation_fee: 0,
        auto_refractor_fee: 0,
        sub_total_amount: 0,
        discount_percentage: 0,
        discount_amount: 0,
        dis_amount: 0,
        dis_percentage: 0,
        total_amount: 0,
        paid_amount: 0,
        due_amount: 0,
        payment_method: 'Cash',
        cashback_amount: 0,
        discount_recommended_dr_id: '',
        discount_recommended_desc: '',
        family_eye_card_no: '',
        opd_refer_patient: '',
        opd_refer_paid_amount: 0,
        opd_refer_discount_amount: 0,
        consultation_type: 'General',
        paid_service_ref_dr: '',
        login_user_id: localStorage.getItem("userId"),
        local_ip_address: localStorage.getItem("local_ip_address"),
      },
      recommendedData: {
        dr_id: '',
        discount_percentage: '',
        description: '',
      },
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Invoices",
          disabled: false,
          href: "/invoices",
        },
        {
          text: "Create Invoice",
          disabled: true,
          href: "",
        },
      ],

      patientSource: [],
      familyCard: [],
      isLoading: false,
      search: null,
      printBtn: true,
      invoice_id: null,
      invoice_created_msg: null,
      bgColorClass: null,
      loadInvestigation_id: {},
      apiUrl: atshq.defaults.headers.common.api_URL,
      baseUrl: atshq.defaults.headers.common.base_URL,
      returnUrl: atshq.defaults.headers.common.app_URL,
      apiBaseUrl: atshq.defaults.headers.common.api_base_URL,
    };
  },
  created() {
    this.permissionCheck()
    if (this.submitData.patient_id) {
      this.getPatient(this.submitData.patient_id);
    }
    this.getPaymentMethods();
    this.getDoctors()
    this.getAppointmentPatient();
    if (this.message) {
      this.$noty.success(this.message)
    }
  },

  methods: {
    permissionCheck() {
      atshq
          .get("users/user-group?id=" + localStorage.getItem("userId"))
          .then((response) => {
            if (response.data.data.includes("admin") || response.data.data.includes("frontdeskexecutive")) {
              console.log(response.data)
            } else {
              this.$router.go(-1);
            }
          })
          .catch((e) => {
            console.log(e + 'Something went wrong')
          });
    },
    print(type) {
      if (type === 'invoice') {
        // window.open(this.returnUrl + "printdoc/invoice/" + this.invoice_id + "/0");

        window.open(this.apiBaseUrl + "print/invoice/" + this.invoice_id);
      }
      if (type === 'prescription') {
        window.open(this.returnUrl + "printdoc/prescription/" + this.invoice_id + "/0");
      }
    },
    getDoctors() {
      atshq
          .get("/doctors-data")
          .then((response) => {
            this.doctors = response.data.data;
          })
          .catch((e) => {
            console.log(e)
          });
    },
    getPaymentMethods() {
      atshq
          .get("/payment-methods")
          .then((response) => {
            this.paymentMethods = response.data.data;
          })
          .catch((e) => {
            this.$noty.error(e.response.data.message);
          });
    },
    getPatient(patient_id) {
      atshq
          .get("patients/patients/" + patient_id)
          .then((response) => {
            this.patient_info = response.data.data;
            this.refer_doctor_name = (this.patient_info.doctor && this.patient_info.doctor.dr_name) || '';
          })
          .catch((e) => {
            console.log(e)
          });
    },
    consultationTypeChange() {
      this.getAppointmentPatient()
    },
    getAppointmentPatient() {
      this.loading = true
      this.btnSubmit = true
      this.invoice_id = '';
      this.spinnerButtons = true;
      atshq
          .get("/appointments/appointments-data?patient_id=" + this.submitData.patient_id + "&doctor_id=" + this.submitData.doctor +
              "&appointment_date=" + this.date + "&appointment_id=" + this.submitData.appointment_id + "&consultation_type=" + this.submitData.consultation_type)
          .then((response) => {
            this.appointment = response.data.appointment;
            this.patientSource = response.data.patientSource;
            this.doctor_name = this.appointment.doctor.dr_name;
            this.show_other_dr_followup = this.appointment.doctor.show_other_dr_followup;
            this.general_consultation_block = this.appointment.doctor.general_consultation_block;
            if (parseInt(this.general_consultation_block) === 1){
              this.submitData.consultation_type='OPD';
            }
            let consultation_fee = parseInt(response.data.consultation_fee)
            this.submitData.cons_fee = consultation_fee
            this.submitData.consultation_fee = consultation_fee
            this.submitData.sub_total_amount = consultation_fee
            this.submitData.total_amount = consultation_fee
            this.submitData.paid_amount = consultation_fee
            if (response.data.familyEyeCard !== null) {
              this.familyCard = response.data.familyEyeCard
              this.submitData.family_eye_card_no = this.familyCard.card_no;
            }
            this.submitData.discount_amount = response.data.discount_amount;
            this.submitData.discount_percentage = this.patientSource.ps_con_discount;
            this.submitData.dis_amount = response.data.discount_amount;
            this.submitData.opd_refer_patient = response.data.opd_refer_patient ;
            this.submitData.opd_refer_paid_amount = response.data.opd_refer_paid_amount ;
            this.submitData.opd_refer_discount_amount = response.data.opd_refer_discount_amount ;
            this.submitData.cashback_amount = parseInt(response.data.cash_back_amount);
            if (this.submitData.consultation_type === 'OPD') {
              if (this.submitData.cashback_amount) {
                this.submitData.dis_percentage = 0;
              } else {
                this.submitData.dis_percentage = this.patientSource.ps_con_discount;
              }
            } else {
              this.submitData.dis_percentage = this.patientSource.ps_con_discount
            }


            this.submitData.total_amount = parseInt(response.data.total_amount)
            this.submitData.paid_amount = this.submitData.total_amount

            this.loading = false
            this.btnSubmit = false
            this.spinnerButtons = false;
          })
          .catch((e) => {
            this.spinnerButtons = false;
            this.$noty.error(e.response.data.message);
          });
    },
    formSubmit() {
      if (this.submitData.consultation_type !== 'CycloplegicRefraction') {
        this.submitData.paid_service_ref_dr = ''
      }

      if (!(this.submitData.paid_amount >= 0 && this.submitData.due_amount >= 0)) {
        this.$noty.error('Paid and Due amount must must be greater than or equal 0')
        return
      }
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'success',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      }).then((result) => {
        if (result.value) {
          this.btnSubmit = true
          let submitUrl = "invoices/invoice-consultation";
          this.spinnerButtons = true;
          atshq
              .post(submitUrl, {submitData: this.submitData})
              .then((response) => {
                this.invoice_id = response.data.invoice_id;
                this.invoice_created_msg = 'Successfully Save Invoice No: ' + this.invoice_id;
                this.bgColorClass = 'bg-color-success'
                this.$noty.success(response.data.message);
                this.spinnerButtons = false;
              })
              .catch((e) => {
                this.btnSubmit = false
                this.$noty.error(e.response.data.message);
                this.spinnerButtons = false;
                if (e.response.status === 409) {
                  this.invoice_id = e.response.data.invoice_id
                  this.invoice_created_msg = 'Invoice Already Created: ' + this.invoice_id;
                  this.bgColorClass = 'bg-color-red'
                }
              });
        }
      });
    },
  },
  computed: {
    dueAmount() {
      let t = this
      let paid_amount = this.submitData.paid_amount
      t.submitData.consultation_fee = paid_amount
      t.submitData.sub_total_amount = paid_amount
      t.submitData.total_amount = paid_amount
      t.submitData.due_amount = 0;
      t.submitData.discount_amount = 0;
      t.submitData.discount_percentage = 0;
      return t.submitData.due_amount
    },
  },
  filters: {
    currency(value) {
      return value.toFixed(2);
    },
  },
};
</script>
  